import axios from "axios"

class AttachmentAPI {
  removeAttachment = async (id, config) => {
    return axios.delete(`api/attachment/${id}`, config)
  }
}

export const attachment = new AttachmentAPI()
